module.exports = __webpack_public_path__ + "static/media/metrics.df46a7fe.png";